import { render } from "./couponclass.vue?vue&type=template&id=6e740e12&ts=true"
import script from "./couponclass.vue?vue&type=script&lang=ts"
export * from "./couponclass.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__